const recurringToString = (recurring: string) => {
    switch (recurring) {
        case "DAILY": return "일";
        case "WEEKLY": return "주";
        case "MONTHLY": return "월";
        case "ANNUALLY": return "년";
    }
}

export default recurringToString;